module.exports = {"140105001":"坞城街道","140105002":"营盘街道","140105003":"北营街道","140105004":"平阳路街道","140105005":"黄陵街道","140105006":"小店街道","140105007":"龙城街道","140105100":"北格镇","140105200":"西温庄乡","140105201":"刘家堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140105.json
// module id = 230
// module chunks = 0